import { render, staticRenderFns } from "./ModulePromotion.vue?vue&type=template&id=1dacd744&"
import script from "./ModulePromotion.vue?vue&type=script&lang=js&"
export * from "./ModulePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports